module.exports = __webpack_public_path__ + "static/media/Kaggle_logo.781448a1.webp";